// https://stackoverflow.com/questions/1117086/how-to-create-a-jquery-plugin-with-methods
(function($) {
  var methods = {
    init: function(options) {
      if ( !$('#recaptcha-script').length ) {
        var recaptchaSiteKey = this.find('input[name="recaptcha3"]').val()
        var body = document.getElementsByTagName('body')[0]
        var script = document.createElement('script')
        script.id = 'recaptcha-script'
        script.type = 'text/javascript'
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + recaptchaSiteKey
        /*
        script.async = true
        script.defer = true
        script.onload = () => {
          grecaptcha.ready(function () {
          // do request for recaptcha token
          // response is promise with passed token
            grecaptcha.execute(recaptchaSiteKey, { action: 'alert' }).then(function (token) {
              // add token value to form
              // document.getElementById('g-recaptcha-response').value = token;
              _this.$f.prepend('<input name="recaptcha3-token" type="hidden" value="' + token + '">')
              // _this.$f.find('input[name="recaptcha3-response"]').val(token)
            })
            setInterval(function () {
              grecaptcha.execute(recaptchaSiteKey, { action: 'alert' }).then(function (token) {
                if (_this.$f.find('input[name="recaptcha3-token"]').length) {
                  console.log('set new token to existing input >> token = ' + token)
                  _this.$f.find('input[name="recaptcha3-token"]').val(token)
                } else {
                  console.error('recaptcha_token does not exist on form')
                }
              })
            }, 60000)
          })
        }
        */
        body.appendChild(script)
      }
    },
    verify: function(actions) {
      var recaptchaSiteKey = this.find('input[name="recaptcha3"]').val()
      var self = this
      grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaSiteKey, { action: actions.action }).then(function (token) {
          //_this.$f.prepend('<input name="recaptcha3-token" type="hidden" value="' + token + '">')
          $.ajax({
            type: 'POST',
            dataType: 'json',
            url: document.location.origin + '/app/Ajax/Recaptcha/verify.php',
            data: { 'g-recaptcha-response': token, 'action': actions.action },
            success (response) {
              switch (response.error) {
                case false:
                  actions.success()
                  break
                case true:
                  self.captcha('fallback', actions)
                  break
              }
              //console.log(response)
            },
            error () {
              actions.error()
            }
          })
        })
      })
    },
    fallback: function(actions) {
      import(/* webpackChunkName: "recaptchaModal" */ '../components/recaptchaModal.js').then((module) => {
        const modal = module.recaptchaModal
        modal.init(actions)
      })
    }
  }
  $.fn.captcha = function(methodOrOptions) {
    if ( methods[methodOrOptions] ) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1))
    } else if ( typeof methodOrOptions === 'object' || !methodOrOptions ) {
      return methods.init.apply(this, arguments) // Default to "init"
    } else {
      $.error('Method ' +  methodOrOptions + ' does not exist on jQuery.captcha')
    }
  }
})(jQuery)
